module.exports = __webpack_public_path__ + "media/Video 153.8a5b3a0d.mp4";